module.exports = __webpack_public_path__ + "assets/54321074.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sport-orange.png
// module id = 106
// module chunks = 0